;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { PropsWithChildren } from 'react';
import { Container } from 'reactstrap';

type Props = PropsWithChildren<{
  className?: string;
  picturePath?: string;
  type: 'white' | 'gray' | 'picture';
}>;

export default function Section({ children, className, picturePath, type }: Props) {
  let style;
  switch (type) {
    case 'white':
      style = '';
      break;
    case 'gray':
      style = 'gray';
      break;
    case 'picture':
      style = '';
      break;
  }
  return (
    <section
      className={`section overflow-hidden ${style} ${className}`}
      style={
        picturePath
          ? {
              backgroundImage: `url(${picturePath})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative',
            }
          : undefined
      }
    >
      {picturePath && <div className="position-absolute top-0 left-0 bg-white opacity-75 w-100 h-100 z-0" />}
      <Container className="position-relative z-1">{children}</Container>
    </section>
  );
}
